import { OpenInNew } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { closeSnackbar, enqueueSnackbar } from "notistack";
import { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { WEBSOCKET_URL } from "../../config";

const WebSocketContext = createContext(null);

const truncateMessage = (message) => {
    if (message.length > 20) {
        return message.slice(0, 20) + "...";
    }
    return message;
};

export const WebSocketProvider = ({ userId, children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const [socket, setSocket] = useState(null);

    useEffect(() => {
        if (!userId) return;

        console.log("🚀 Connecting to WebSocket")
        console.log("🚀 userId: ", userId);

        // Initialize WebSocket connection
        const ws = new WebSocket(
            `${WEBSOCKET_URL}/?userId=` +
                userId
        );

        ws.onopen = () => console.log("✅ WebSocket Connected");
        ws.onclose = () => console.log("❌ WebSocket Disconnected");
        ws.onerror = (error) => console.error("⚠ WebSocket Error", error);

        function onSocketMessage(event) {
            const messageData = JSON.parse(event.data);
            console.log("📩 Message received:", messageData);
            if (['default', 'new_chat'].includes(messageData.notification_type)) {
                if (location.pathname.startsWith('/support') && searchParams.get('chatId') === String(messageData.active_chat_id)) {
                    return;
                }

            
            
            

                // TODO: https://developer.mozilla.org/en-US/docs/Web/API/Notifications_API
                const audio = new Audio('/audio/message-notification-tone.mp3');
                audio.play().catch((error) => console.error("⚠ Message Notification Error", error));

                enqueueSnackbar(
                    `New message from ${messageData.sender_type}: ${truncateMessage(messageData.message)}`,
                    {
                        variant: "info",
                        autoHideDuration: 5000,
                        action: (messageId) => (
                            <IconButton
                                size="small"
                                onClick={() => {
                                    navigate(`/support/?chatId=${messageData.active_chat_id}`);
                                    closeSnackbar(messageId);
                                }}
                                sx={{ color: 'white' }}
                            >
                                <OpenInNew />
                            </IconButton>
                        ),
                    }
                );
            }
        }

        ws.addEventListener(('message'), onSocketMessage);

        setSocket(ws);

        return () => {
            ws.removeEventListener(('message'), onSocketMessage);
            ws.close();
        };
    }, [location.pathname, navigate, searchParams, userId]);

    return (
        <WebSocketContext.Provider value={{ socket }}>
            {children}
        </WebSocketContext.Provider>
    );
};

export const useWebSocket = ({ onMessage }) => {
    const context = useContext(WebSocketContext);
    
    useEffect(() => {
        // Add null check for context and context.socket
        if (!context || !context.socket) return;

        function onSocketMessage(event) {
            onMessage(JSON.parse(event.data));
        }

        context.socket.addEventListener(('message'), onSocketMessage);

        return () => {
            context.socket.removeEventListener('message', onSocketMessage);
        };
    }, [context?.socket, onMessage]);

    return context;
};
